import React from 'react'
import './Exp.css'
import {BsPatchCheckFill} from 'react-icons/bs'
 const Exp = () => {
    return (
        <section id="experience"> 
            <h5>What Skills Did I Have </h5>
            <h2>MY EXPERIENCE</h2>
            <div className="container experience_container">
                <div className="experience_frontend">
                    <h3>Front-End Development</h3>
                    <div className="experience_content">
                        <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>HTML</h4>
                            <small className='text-light'>Guru</small>
                            </div>
                            </article>
                            <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>CSS</h4>
                            <small className='text-light'>Intermediate</small>
                            </div>
                            </article>
                            <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                          <div>
                          <h4>Javascript</h4>
                            <small className='text-light'>Intermediate</small>
                          </div>
                            </article>
                            <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>Java</h4>
                            <small className='text-light'>Beginner</small>
                            </div>
                            </article>
                            <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>Bootstrap</h4>
                            <small className='text-light'>Beginner</small>
                            </div>
                            </article>
                            <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>Saas/Scss</h4>
                            <small className='text-light'>Beginner</small>
                            </div>
                        </article>
                    </div>
                </div>
                <div className="experience_backend">
                <h3>Back-End Development</h3>
                    <div className="experience_content">
                        <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>Python</h4>
                            <small className='text-light'>Guru</small>
                            </div>
                            </article>
                            <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>Mongo-Db</h4>
                            <small className='text-light'>Intermediate</small>
                            </div>
                            </article>
                            <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>ReactJs</h4>
                            <small className='text-light'>Guru</small>
                            </div>
                            </article>
                            <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>XML</h4>
                            <small className='text-light'>Beginner</small>
                            </div>
                            </article>
                            <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>MySql</h4>
                            <small className='text-light'>Beginner</small>
                            </div>
                            </article>
                            <article className='exp_details'>
                            <BsPatchCheckFill className="exp_icons" />
                            <div>
                            <h4>NodeJs</h4>
                            <small className='text-light'>Beginner</small>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Exp
